<script lang="ts">
	import SiteSearch from '$lib/SiteSearch.svelte';
	import { slide } from 'svelte/transition';
</script>

<div
	transition:slide={{ duration: 200 }}
	class="page-wrapper bg-cultured fixed top-14 left-0 z-30 h-full w-full"
>
	<div class="relative top-4">
		<SiteSearch />
		<header class="text-gray-mid mt-6 mb-2 text-xs font-medium">Suggested</header>
		<ul class="grid gap-2 font-medium">
			<li>
				<a class="search-suggestion" data-sveltekit-reload href="/search?q=t-bill">T-bill</a>
			</li>
			<li>
				<a class="search-suggestion" data-sveltekit-reload href="/quote/Z74.SI">SINGTEL</a>
			</li>
			<li>
				<a class="search-suggestion" data-sveltekit-reload href="/search?q=ssb">SSB</a>
			</li>
		</ul>
	</div>
</div>
